import { render, staticRenderFns } from "./ProductBaseInfo.vue?vue&type=template&id=fa1eac70&"
import script from "./ProductBaseInfo.vue?vue&type=script&lang=js&"
export * from "./ProductBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductBaseInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports